import React from 'react'
import style from './index.module.less'
import ArrowRight from '@/images/SVG/arrow-right.svg'
import xrealLogo from "@/images/xreal_logo.svg"
import { useIntl } from 'react-intl';
import useNavigate from '@/hooks/useNavigate'

const SupportsMobile = ({ supportsList }) => {
  const intl = useIntl();
  const navigate = useNavigate;

  const goLink = (link, link_out) => {
    if (link_out) {
      window.open(link)
    } else {
      navigate(link)
    }
  }

  return (
    <div className={style.supportsMobile}>
      {supportsList.map((sItem, sIndex) => ( 
          <div className={style.supportsContent} key={`sm${sItem.title}-${sIndex}`}>
            <div className={style.contentLeft}>
              <div className={style.video}>
                <img
                  src={sItem.img || xrealLogo}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = xrealLogo;
                  }}
                  width={48}
                  height={48}
                />
              </div>
              <div className={style.contentLeftText}>
                <div className={style.title}>{intl.formatMessage({ id: sItem.title })}</div>
                {sItem.desc &&<div className={style.desc}>{intl.formatMessage({ id: sItem.desc })}</div>}
              </div>
            </div>
            
            <div onClick={() => goLink(sItem.learn_link, sItem.learn_out)}>
              <ArrowRight className={style.arrowRight} />
            </div>
          </div>
        )
      )}
      
    </div>
  )
}

export default SupportsMobile